import {throttle} from 'lodash';
import React, {ComponentType, FC, memo, PropsWithChildren, useCallback} from 'react';
import {Subtract} from 'utility-types';

import {DraftMessageModel} from '../../../../../libs/shared/core/src/models/api/messageModel';
import {ChatPushProps} from '../../../push/chatPushContext';
import {ChatComposerPublicProps} from '../chatComposer';

/*
 * HOC.
 */

export interface ChatPrecogPublicProps {
  message: DraftMessageModel;
  emitChatPrecog: (conversationId: number, data: any) => void;
}

/* Props supplied by withChatPrecog. */
export interface ChatPrecogProps {
  updateChatPrecog: () => void;
}

/* Props that children must have. */
type ChatPrecogChildProps = ChatComposerPublicProps & ChatPrecogPublicProps & ChatPrecogProps & ChatPushProps;

export function withChatPrecog<T extends ChatPrecogChildProps>(
  Component: ComponentType<PropsWithChildren<T>>,
): FC<PropsWithChildren<Subtract<T, ChatPrecogProps>>> {
  return memo((props) => {
    const updateChatPrecogThrottled = useCallback(
      throttle(
        async () => {
          try {
            props.emitChatPrecog(props.message.conversationId, {});
          } catch (e) {
            // An exception is raised if the room is left before we're actually able to send the update.
          }
        },
        500,
        {leading: true, trailing: false},
      ),
      [props.message.conversationId],
    );

    return <Component {...(props as any)} updateChatPrecog={updateChatPrecogThrottled} />;
  });
}
